<template>
        <div class="room-booking-summary">

        <div class="has-shadow panel panel--primary mb-4">
            <div class="row">
                <div class="col-24">
                    <div class="room-leg-wrapper">
                        <h3>Room {{roomBooking.leg}}:</h3>
                    </div>



                    <div class="room-detail-wrapper">
                        <div class="room-detail-section room-detail-section--shallow">
                            <h4 class="title">Room, Rate &amp; Add Ons:</h4>

                            <div v-if="stayVouchers.length" class="mt-3 mb-3">
                                <info-box v-bind:type="'success'">
                                    <template v-slot:body>
                                        <span class="heading">
                                            Gift Vouchers

                                        </span>

                                        <div>
                                            <ul class="m-0">
                                                <li v-for="(a) in stayVouchers">
                                                    <span>
                                                        {{a.voucher.orderItemId}} - {{a.voucher.voucherName}}
                                                    </span>
                                                </li>
                                            </ul>
                                        </div>
                                    </template>
                                </info-box>

                            </div>

                            <div class="room-detail-item" v-if="isConfirmationPage">
                                <div class="row ">
                                    <div class="col-8">
                                        <span class="info-title">Dates:</span>
                                    </div>
                                    <div class="col-15">
                                        {{dates}}
                                    </div>


                                </div>
                                <div class="col-1">
                                    <button class="edit" v-if="allowEdit" v-on:click="onEditGuestQuota()">Edit</button>
                                </div>
                            </div>


                            <div class="room-detail-item">
                                <div class="row ">
                                    <div class="col-8">
                                        <span class="info-title">Guests:</span>
                                    </div>
                                    <div class="col-15">
                                        {{guests}}
                                    </div>


                                </div>
                                <div class="col-1">
                                    <button class="edit" v-if="allowEdit" v-on:click="onEditGuestQuota()">Edit</button>
                                </div>
                            </div>

                            <div class="room-detail-item" v-if="hasDog">
                                <div class="row ">
                                    <div class="col-8">
                                        <span class="info-title">Dogs:</span>
                                    </div>
                                    <div class="col-15">
                                        {{dogs}}
                                    </div>


                                </div>
                                <div class="col-1">
                                    <button class="edit" v-if="allowEdit" v-on:click="onEditGuestQuota()">Edit</button>
                                </div>
                            </div>


                            <div class="room-detail-item">
                                <div class="row mb-1">
                                    <div class="col-8">
                                        <span class="info-title">Room:</span>
                                    </div>
                                    <div class="col-15">
                                        {{roomBooking.room.DisplayName}}
                                    </div>
                                </div>
                                <div class="col-1">
                                    <button class="edit" v-if="allowEdit" v-on:click="onEditRoom()">Edit</button>

                                </div>
                            </div>

                            <div class="room-detail-item">
                                <div class="row mb-1">
                                    <div class="col-8">
                                        <span class="info-title">Rate:</span>
                                    </div>
                                    <div class="col-15">
                                        {{roomBooking.rate.rateGroupRate.DisplayName}}
                                    </div>
                                </div>
                                <div class="col-1">
                                    <button class="edit" v-if="allowEdit" v-on:click="onEditRate()">Edit</button>
                                </div>
                            </div>

                            <div class="room-detail-item" v-if="roomBooking.packages">
                                <div class="row mb-1">
                                    <div class="col-8">
                                        <span class="info-title">Add Ons:</span>
                                    </div>
                                    <div class="col-15">
                                        <div v-for="(p) in roomBooking.packages">

                                            <span v-if="p.item.availability.PriceCalculationMode == 0">{{p.quantity}} x </span>
                                            {{p.item.content.DisplayName}}
                                        </div>
                                    </div>
                                </div>
                                <div class="col-1">
                                    <button class="edit" v-if="allowEdit" v-on:click="onEditAddOns()">Edit</button>
                                </div>
                            </div>


                        </div>

                        <div class="room-detail-section">
                            <h4 class="title">Room {{roomBooking.leg}} Bill:</h4>
                            <div class="room-detail-item">
                                <div class="row mb-1">
                                    <div class="col-8">
                                        <span class="info-title">Room &amp; rate:</span>
                                    </div>
                                    <div class="col-15">
                                        <strong>
                                            &pound;{{priceFormatted(getRoomRateAmount(roomBooking))}}

                                        </strong>
                                    </div>
                                </div>
                            </div>




                            <div v-if="roomBooking.includedPackages != null && roomBooking.includedPackages.length"  v-for="ri in roomBooking.includedPackages" class="room-detail-item" >
                                <div class="row mb-1">
                                    <div class="col-8">
                                        <span class="info-title" v-if="ri.Code == 'CHILD'">Children:</span>
                                        <span class="info-title" v-else-if="ri.Code == 'BABY'">Infants:</span>
                                        <span class="info-title" v-else-if="ri.Code == 'DOG'">Dogs:</span>
                                    </div>
                                    <div class="col-15">
                                        <strong>
                                            

                                            &pound;{{priceFormatted(ri.Total)}}

                                        </strong>
                                    </div>
                                </div>
                            </div>
                        

                            <div class="room-detail-item" v-if="roomBooking.spaPackages && getSpaUpgradeAmount(roomBooking)> 0">
                                <div class="row mb-1">
                                    <div class="col-8">
                                        <span class="info-title">Spa  upgrades:</span>
                                    </div>
                                    <div class="col-15">
                                        <strong>
                                            &pound;{{priceFormatted(getSpaUpgradeAmount(roomBooking))}}

                                        </strong>
                                    </div>
                                </div>
                            </div>



                            <div class="room-detail-item" v-if="roomBooking.packages">
                                <div class="row mb-1">
                                    <div class="col-8">
                                        <span class="info-title">Add Ons:</span>
                                    </div>
                                    <div class="col-15">
                                        <strong>
                                            &pound;{{priceFormatted(getAddOnsTotal(roomBooking))}}

                                        </strong>
                                    </div>
                                </div>
                            </div>

                            <div class="room-detail-item room-detail-item--voucher" v-if="appliedVoucherValue(roomBooking) > 0">
                                <div class="row mb-1">
                                    <div class="col-8">
                                        <span class="info-title">Gift vouchers:</span>
                                    </div>
                                    <div class="col-15">
                                        <strong>
                                            -&pound;{{priceFormatted(appliedVoucherValue(roomBooking))}}

                                        </strong>
                                    </div>
                                </div>
                            </div>


                            <div class="room-detail-item">
                                <div class="row mb-1">
                                    <div class="col-8">
                                        <span class="info-title">Total:</span>
                                    </div>
                                    <div class="col-15">
                                        <strong>
                                            &pound;{{priceFormatted(getPayable(roomBooking))}}

                                        </strong>
                                    </div>
                                </div>
                            </div>

                            <!--   <div class="mb-3" v-if="roomBooking.rate.availableRate.RequiresDeposit || getAddOnsTotal(roomBooking) > 0">

        <info-box v-bind:type="'success'">
            <template v-slot:body>
                <span class="heading">
                    Payment due today

                </span>

                <div >
                    <p>
                        Payment for this room will be taken from your selected payment method to complete this booking. Please note transactions can take up to 24 hours to process.
                    </p>
                </div>
            </template>
        </info-box>
    </div>
    <div  class="mb-3" v-if="!roomBooking.rate.availableRate.RequiresDeposit">
        <info-box v-bind:type="'alert'">
            <template v-slot:body>
                <span class="heading">
                    Payment due on arrival
                </span>

                <div>
                    <p>
                        Payment will be taken via your selected payment method.
                    </p>
                    <ul>
                        <li>A credit card guarantee will be taken on the lead booker's card to secure your booking</li>
                    </ul>
                </div>
            </template>
        </info-box>
    </div>

     -->




                            <div v-if="stayVouchers.length || appliedVoucherValue(roomBooking) > 0" class="mt-3">
                                <info-box v-bind:type="'alert'">
                                    <template v-slot:body>
                                        <span class="heading">
                                            Gift Voucher

                                        </span>

                                        <div>
                                            <p>
                                                You must bring your gift voucher on the day of arrival, otherwise it cannot be accepted as a payment method.
                                            </p>
                                        </div>
                                    </template>
                                </info-box>

                            </div>
                        </div>





                        <div class="room-detail-section">
                            <h4 class="title">Guests</h4>

                            <div class="room-detail-item">
                                <div class="row mb-1">
                                    <div class="col-8">
                                        <span class="info-title">Names:</span>
                                    </div>
                                    <div class="col-15">
                                        <ul class="guest-names">
                                            <li v-bind:key="index"
                                                v-for="(guest, index) in roomBooking.guests">
                                                {{guest.title}} {{guest.firstName}} {{guest.lastName}}
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="col-1">
                                    <button class="edit" v-if="allowEdit" v-on:click="onEditGuestNames()">Edit</button>

                                </div>
                            </div>
                        </div>



                        <div class="room-detail-section"
                             v-if="roomBooking.dinner || roomBooking.golf || roomBooking.breakfast || restaurantPackages(roomBooking).length || golfPackages(roomBooking).length || spaPackages(roomBooking).length || roomBooking.spaPackages != null">
                            <h4 class="title">Itinerary:</h4>

                            <div v-if="roomBooking.rate.rateGroupRate.IncludesGolf && roomBooking.golf" class="row itinerary-item py-4 itinerary-item--golf ">
                                <div class="col-24 col-sm-21 offset-sm-3">

                                    <span class="intinerary-label">Golf Package Extras</span>


                                    <div v-if="roomBooking.golf">
                                        <div class="itinerary-selection">
                                            <span class="itinerary-selection-title">Tee-off time:</span>
                                            <div class="itinerary-selection-detail">

                                                <button class="edit" v-if="allowEdit" v-on:click="editGolf()">Edit</button>



                                                <ul>
                                                    <li v-for="(golf, index) in roomBooking.golf">

                                                        {{formatLongDateTime(golf.Time.DateTime)}}
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>

                                    </div>






                                </div>
                            </div>


                            <div v-if="roomBooking.breakfast" class="row itinerary-item py-4 itinerary-item--breakfast ">
                                <div class="col-24 col-sm-21 offset-sm-3">

                                    <span class="intinerary-label">Breakfast Times</span>



                                    <div class="itinerary-selection">
                                        <div class="itinerary-selection-detail">

                                            <button class="edit" v-if="allowEdit" v-on:click="editBreakfast()">Edit</button>

                                            <ul v-if="roomBooking.breakfast.filter(item => item.isAvailable).length">
                                                <li v-for="(breakfast, index) in roomBooking.breakfast">
                                                    <strong>
                                                        {{formatShortDate(breakfast.date)}}:
                                                    </strong>
                                                    <span class="d-block d-xl-inline">
                                                        {{getBreakfastRestaurantName(breakfast.restaurant)}} - {{formatTime(breakfast.timeslot)}}
                                                    </span>
                                                </li>
                                            </ul>
                                            <div v-if="!roomBooking.breakfast.filter(item => item.isAvailable).length">

                                                <p v-if="!isConfirmationPage">Unfortunately at present there is no availability for your selected dates. Please complete your preferred dining times in the comments box on the Guest Details screen and the team will be in touch to confirm.</p>
                                                <p v-else>No times selected. Please contact a member of the team should you wish to update or amend your restaurant reservations.</p>
                                            </div>
                                        </div>
                                    </div>

                                </div>


                            </div>


                            <div v-if="roomBooking.dinner" class="row itinerary-item py-4 itinerary-item--dinner ">
                                <div class="col-24 col-sm-21 offset-sm-3">
                                    <span class="intinerary-label">Dinner Times</span>
                                    <div class="itinerary-selection">
                                        <div class="itinerary-selection-detail">
                                            <button class="edit" v-if="allowEdit" v-on:click="editdinner()">Edit</button>
                                            <ul v-if="roomBooking.dinner.filter(item => item.isAvailable).length">
                                                <li v-for="(dinner, index) in roomBooking.dinner">
                                                    <strong>
                                                        {{formatShortDate(dinner.date)}}:
                                                    </strong>
                                                    <span class="d-block d-xl-inline">
                                                        {{getDinnerRestaurantName(dinner.restaurant)}} - {{formatTime(dinner.timeslot)}}
                                                    </span>
                                                </li>
                                            </ul>
                                            <div v-if="!roomBooking.dinner.filter(item => item.isAvailable).length">

                                                <p v-if="!isConfirmationPage">Unfortunately at present there is no availability for your selected dates. Please complete your preferred dining times in the comments box on the Guest Details screen and the team will be in touch to confirm.</p>
                                                <p v-else>No times selected. Please contact a member of the team should you wish to update or amend your restaurant reservations.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                            <div v-if="restaurantPackages(roomBooking).length" class="row itinerary-item py-4 itinerary-item--dinner ">
                                <div class="col-24 col-sm-21 offset-sm-3">
                                    <span class="intinerary-label">Dinner Add Ons</span>
                                    <div class="itinerary-selection">
                                        <div class="itinerary-selection-detail">
                                            <button class="edit" v-if="allowEdit" v-on:click="onEditAddOns()">Edit</button>
                                            <ul v-for="(p, index) in restaurantPackages(roomBooking)">
                                                <li v-for="(dinner, index) in p.selections">
                                                    <strong>
                                                        {{p.item.content.Restaurant.DisplayName}}:
                                                    </strong>
                                                    <span class="d-block d-xl-inline">
                                                        {{formatShortDate(dinner.date)}} - {{formatTime(dinner.selection)}}
                                                    </span>
                                                </li>
                                            </ul>

                                        </div>
                                    </div>
                                </div>
                            </div>


                            <div v-if="golfPackages(roomBooking).length" class="row itinerary-item py-4 itinerary-item--golf ">
                                <div class="col-24 col-sm-21 offset-sm-3">

                                    <span class="intinerary-label">Golf Add Ons</span>


                                    <div>
                                        <div class="itinerary-selection">
                                            <span class="itinerary-selection-title">Tee-off time:</span>
                                            <div class="itinerary-selection-detail">

                                                <button class="edit" v-if="allowEdit" v-on:click="onEditAddOns()">Edit</button>



                                                <ul v-for="(golf, index) in golfPackages(roomBooking)">

                                                    <li v-for="(s, index) in golf.selections">

                                                        <strong>
                                                            {{formatShortDate(s.date)}}  &nbsp;-&nbsp;{{formatTime(s.selection.Time)}}
                                                        </strong>
                                                        <span class="d-block d-xl-inline">
                                                            &nbsp;-&nbsp; {{s.quantity}} {{s.quantity == 1 ? 'player' : 'players' }}
                                                        </span>

                                                    </li>
                                                </ul>
                                            </div>
                                        </div>

                                    </div>






                                </div>
                            </div>



           
                            <div v-if="roomBooking.spaPackages != null" class="row itinerary-item py-4 itinerary-item--spa-pool">
                                <div class="col-24 col-sm-21 offset-sm-3">

                                    <span class="intinerary-label">Spa Package</span>


                                    <div>
                                        <div class="itinerary-selection">

                                            <div class="itinerary-selection-detail">

                                                <button class="edit" v-if="allowEdit" v-on:click="onEditAddOns()">Edit</button>


                                                <div v-for="(item, pi) in roomBooking.spaPackages" class="mb-2">
                                                    <strong>{{roomBooking.guests[item.guestIndex].firstName}}: {{item.treatment.DisplayName}} - {{item.duration.Duration}}mins</strong>
                                                    <span class="d-block">{{formatSpaTime(item.time.StartTime)}}</span>
                                                </div>


                                            </div>
                                        </div>

                                    </div>


                                </div>
                            </div>




                            <div v-if="spaPackages(roomBooking).length" class="row itinerary-item py-4 itinerary-item--spa-pool">
                                <div class="col-24 col-sm-21 offset-sm-3">

                                    <span class="intinerary-label">Spa Treatments</span>


                                    <div>
                                        <div class="itinerary-selection">

                                            <div class="itinerary-selection-detail">

                                                <button class="edit" v-if="allowEdit" v-on:click="onEditAddOns()">Edit</button>


                                                <div v-for="(person, pi) in personTreatments(roomBooking)">
                                                    <strong>{{person.key}}</strong>

                                                    <ul>

                                                        <li v-for="(item, index) in person.items">

                                                            {{item.meta.displayName}}&nbsp;-&nbsp;{{formatShortDate(item.date)}}&nbsp;-&nbsp;{{formatTime(item.date)}}


                                                        </li>
                                                    </ul>

                                                </div>


                                            </div>
                                        </div>

                                    </div>






                                </div>
                            </div>




                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>


</template>

<script>
    import InfoBox from '@/shared/components/InfoBox.vue';
    import { _ } from 'vue-underscore';

    import { store } from '../store/index';

    export default {
        name: 'RoomBookingSummary',
        props: {
            leg: String,
            allowEdit: Boolean,
            isPastTense: {
                type: Boolean,
                default: false
            },
            isConfirmationPage:
            {
                type: Boolean,
                default: false
            }
        },

        components: {
            InfoBox
        },
        computed: {
            dates() {
                var booking = store.getters.booking;
                var arrivalDate = moment(booking.arrivalDate);
                var departureDate = moment(booking.arrivalDate).add(+booking.numberOfNights, 'd');

                if ((arrivalDate.year() == departureDate.year()) && (arrivalDate.month() == departureDate.month())) {
                    return arrivalDate.format('ddd Do') + '-' + departureDate.format('ddd Do MMM YY');
                }
                if (arrivalDate.year() == departureDate.year()) {
                    return arrivalDate.format('ddd Do MMM') + '-' + departureDate.format('ddd Do MMM YY');
                }
                return arrivalDate.format('ddd Do MMM YY') + '-' + departureDate.format('ddd Do MMM YY');

            },
            stayVouchers() {

                let result = this.booking.monetaryVouchers != undefined && this.booking.monetaryVouchers != null && this.booking.monetaryVouchers.filter(item => !item.content.IsMonetary);

                if (result != undefined && result != null && result.length) {
                    return result;
                }

                return [];
            },
            session() {
                return store.getters.session;
            },
            search() {
                return store.getters.search;
            },

            booking() {
                return store.getters.booking;
            },
            roomBooking() {
                return this.booking.legs.find(leg => leg.leg == this.leg);
            },
            hasDog() {

                let guestQuota = this.roomBooking.guestQuota;
                return guestQuota.Dogs > 0;
            },
            dogs() {
                let result = '';

                let guestQuota = this.roomBooking.guestQuota;

                if (guestQuota.Dogs > 0) {
                    if (guestQuota.Dogs == 1) {
                        result += guestQuota.Dogs + ' dog';
                    }
                    else {
                        result += guestQuota.Dogs + ' dogs';
                    }
                }

                return result;
            },
            guests() {
                let result = '';
                let guestOccpancy = this.roomBooking.guestQuota;
                if (guestOccpancy.Adults > 0) {
                    if (guestOccpancy.Adults == 1) {
                        result += guestOccpancy.Adults + ' adult';
                    }
                    else {
                        result += guestOccpancy.Adults + ' adults';
                    }
                }

                var children = guestOccpancy.ChildAges.filter(item => +item > 3).length;
                var infants = guestOccpancy.ChildAges.filter(item => +item <= 3).length;

                if (children > 0) {
                    if (children == 1) {
                        if (infants == 0) {
                            result += " & ";
                        }
                        else {
                            result += ", ";
                        }

                        result += " 1 child"
                    } else {
                        if (infants == 0) {
                            result += " & ";
                        } else {
                            result += ", ";
                        }

                        result += children + " children"
                    }
                }
                if (infants > 0) {

                    if (infants == 1) {
                        result += " & 1 infant"
                    } else {
                        result += " & " + infants + " infants"
                    }
                }


                return result;

            }

        },
        methods: {
            getSpaUpgradeAmount(item) {
                var result = 0;
                if (item.spaPackages != null) {
                    for (var i = 0; i < item.spaPackages.length; i++) {
                        var it = item.spaPackages[i];

                        result += it.duration.PriceDifference;
                    }
                }

                return result;
            },
            formatSpaTime(item) {
                return moment(item).format('ddd Do MMM YY - h:mma')
            },

            stayVoucherValue(leg) {
                if (this.stayVouchers.length) {
                    let amount = this.stayVouchers.reduce(function (a, b) {

                        return b.voucher.unitPrice.amount + a
                    }, 0)

                    return amount;

                }
                return 0;
            },
            appliedVoucherValue(leg) {
                //need to make this handle other legs...
                //This is the actual total...

                let stayVoucherValue = this.stayVoucherValue(leg);

                let giftVoucherTotal = store.getters.giftVoucherMonetaryTotal;

                //nowe we need the total of all preceeding legs... so we can see whats available.
                let appliedTotal = 0;

                let legsToApply = store.getters.booking.legs.filter(item => item.leg < +(leg.leg))

                for (var li = 0; li < legsToApply.length; li++) {

                    appliedTotal = this.getTotal(legsToApply[li]);
                }

                let availableVouhcerValue = giftVoucherTotal - appliedTotal + stayVoucherValue;

                if (availableVouhcerValue > 0) {
                    let thisTotal = this.getTotal(leg);
                    if (thisTotal > availableVouhcerValue) {
                        return availableVouhcerValue;
                    } else {
                        return thisTotal;
                    }
                }
                return 0;
            },
            getBreakfastRestaurantName(input) {
                return this.roomBooking.rate.rateGroupRate.BreakfastRestaurants.find(item => item.RestaurantId == input).DisplayName;
            },
            getDinnerRestaurantName(input) {
                return this.roomBooking.rate.rateGroupRate.DinnerRestaurants.find(item => item.RestaurantId == input).DisplayName;
            },
            onEditGuestQuota: function () {
                this.$router.push({ name: 'stay_search', params: { id: this.session.Id } });
            },
            onEditRoom: function () {
                this.$router.push({ name: 'stay_leg_room_availability', params: { id: this.session.Id, leg: this.leg } });
            },
            onEditRate: function () {
                this.$router.push({ name: 'stay_leg_room_rates', params: { id: this.session.Id, leg: this.leg } });
            },
            onEditGuestNames: function () {
                this.$router.push({ name: 'stay_guests', params: { id: this.session.Id } });
            },
            onEditAddOns: function () {
                this.$router.push({ name: 'stay_addons', params: { id: this.session.Id } });
            },
            formatLongDateTime(input) {
                var date = moment(input);
                return date.format('ddd Do MMM - HH:mm')
            },
            formatShortDate(input) {
                var date = moment(input);
                return date.format('dddd')
            },

            formatTime(input) {
                var date = moment(input);
                return date.format('HH:mm')
            },
            editGolf() {
                this.$router.push({ name: 'stay_itinerary', params: { id: this.session.Id } });

            },
            editBreakfast() {
                this.$router.push({ name: 'stay_itinerary', params: { id: this.session.Id } });

            },
            editDinner() {
                this.$router.push({ name: 'stay_itinerary', params: { id: this.session.Id } });

            },
            getTotal(leg) {
                let result = 0;
                result = result + this.getRoomRateAmount(leg);
                result = result + this.getIncludedAddOnsTotal(leg);
                result = result + this.getAddOnsTotal(leg);
                result = result + this.getSpaUpgradeAmount(leg);
                return result;
            },
            getPayable(leg) {
                let result = 0;
                result = this.getTotal(leg) - this.appliedVoucherValue(leg);

                if (result < 0) {
                    result = 0;
                }
                return result;
            },
            getRoomRateAmount(leg) {
                let result = 0;
                result = leg.rate.availableRate.Amount;
                return result;
            },

            getIncludedAddOnsTotal(leg) {
                let result = 0;
                if (leg.includedPackages != undefined && leg.includedPackages.length) {
                    for (let pi = 0; pi < leg.includedPackages.length; pi++) {
                        let p = leg.includedPackages[pi];
                        let amount = p.Total;
                        result += amount;
                    }
                }
                return result;
            },
            getAddOnsTotal(leg) {
                let result = 0;

                if (leg.packages != undefined && leg.packages.length) {
                    for (let pi = 0; pi < leg.packages.length; pi++) {
                        let p = leg.packages[pi];
                        let amount = this.getPackagePrice(leg, p);
                        result += amount;
                    }
                }

                return result;
            },
            getPackagePrice(leg, p) {
                if (p.item.availability.AmountOverride != undefined) {
                    return p.quantity * p.item.availability.AmountOverride;
                }


                let amount = p.item.availability.Amount;
                let postingMode = p.item.availability.PriceCalculationMode;
                let result = 0;


                switch (postingMode) {
                    case 0:
                        result = amount * p.quantity;
                        break;
                    case 1:

                        result = amount * leg.guestQuota.Adults;
                        break;
                    case 2:
                        result = amount * (leg.guestQuota.Children + leg.guestQuota.Infants);
                        break;
                    case 3:
                        result = amount * (leg.guestQuota.Adults + leg.guestQuota.Children + leg.guestQuota.Infants);
                        break;
                    case 4:
                        result = amount * p.quantity;
                        break;
                }
                return result;

            },

            priceFormatted(num) {
                if (num % 1 == 0) {
                    return num;
                }

                return num.toFixed(2);
            },
            restaurantPackages(roomBooking) {
                let result = [];

                if (roomBooking.packages != undefined && roomBooking.packages != null) {

                    result = roomBooking.packages.filter(p => p.item.content.Restaurant != undefined && p.item.content.Restaurant != null);
                }

                return result;
            },
            golfPackages(roomBooking) {

                let result = [];

                if (roomBooking.packages != undefined && roomBooking.packages != null) {

                    result = roomBooking.packages.filter(p => p.item.content.IsGolf);
                }

                return result;
            },
            spaPackages(roomBooking) {
                let result = [];

                if (roomBooking.packages != undefined && roomBooking.packages != null) {

                    result = roomBooking.packages.filter(p => p.item.content.Spa != null);
                }

                return result;
            },
            personTreatments(roomBooking) {
                let selections = [];
                let packages = this.spaPackages(roomBooking);

                for (let pi = 0; pi < packages.length; pi++) {
                    let pckg = packages[pi];
                    selections.push(...pckg.selections)
                }

                let grouped = _.groupBy(selections, function (s) { return s.meta.guest.firstName + ' ' + s.meta.guest.lastName; });
                var cleanSelections = _.map(grouped, function (a, b) {
                    return {
                        key: b,
                        items: a
                    }
                });

                return cleanSelections;

            }
        }
    }
</script>

<style src="@/modules/stay/css/components/room-booking-summary.css"></style>
